var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIndustrial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 12,
    fill: "#F8C831"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8672 45C22.1174 45 21.6343 44.2053 21.9794 43.5397L26.7861 34.2698C27.1058 33.653 26.7148 32.9062 26.0258 32.8176L17.0374 31.662C16.2104 31.5556 15.8691 30.5433 16.463 29.9579L33.3747 13.2878C33.5618 13.1034 33.8139 13 34.0767 13H35.1328C35.8826 13 36.3657 13.7947 36.0206 14.4603L31.2139 23.7302C30.8942 24.347 31.2852 25.0938 31.9742 25.1824L40.9626 26.338C41.7896 26.4444 42.1309 27.4567 41.537 28.0421L24.6253 44.7122C24.4382 44.8966 24.1861 45 23.9233 45H22.8672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndustrial);
export default __webpack_public_path__ + "static/media/icon-industrial.857ae0ea4f7033aea2cffd78d1567182.svg";
export { ForwardRef as ReactComponent };